import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { TranslatePipe } from '../shared/pipe/translate.pipe';
import { TranslationService } from '../services/translation.service';

export function initTranslations(service: TranslationService) {
  return () => service.subscribeForLanguagesAsync();
}

@NgModule({
  declarations: [TranslatePipe],
  imports: [],
  exports: [TranslatePipe],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    TranslatePipe,
    //{
    //  provide: APP_INITIALIZER,
    //  useFactory: initTranslations,
    //  deps: [TranslationService, Store, ConfigService],
    //  multi: true,
    //},
  ],
})
export class CoreModule {}
